import React from "react"

import WPImage, {DISPLAY_MODE} from "./_base/WPImage"

import ComponentFactory from "./parsers/ComponentFactory"

import { Trans } from "gatsby-plugin-react-i18next"

import * as sliderSectionStyles from "../styles/SliderSection.module.css"

const NUMBER_OF_NEWS_ITEMS = 2

/* const newsContent = elem => {
  const content = elem.props && elem.props.content
  if (!content) return ``

  const newsContentNode = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("news-visual-assets")
  )[0]

  return ImageTransformer(newsContentNode)
} */

const imageHolderNode = item => {
  if (
    !item ||
    !item.props ||
    !item.props.content ||
    !item.props.content.childNodes
  )
    return null

  return item.props.content || null
  return item.props.content.childNodes[0] || null
}

const sliderFilterPerNav = (sliderCollection, activeIndx, startingIndx) => {
  // if already within sliding window
  if (
    activeIndx >= startingIndx &&
    activeIndx < startingIndx + NUMBER_OF_NEWS_ITEMS
  )
    return sliderCollection.slice(
      startingIndx,
      Math.min(startingIndx + NUMBER_OF_NEWS_ITEMS, sliderCollection.length)
    )

  return sliderCollection.slice(
    Math.min(
      activeIndx,
      Math.max(0, sliderCollection.length - NUMBER_OF_NEWS_ITEMS)
    ),
    Math.min(activeIndx + NUMBER_OF_NEWS_ITEMS, sliderCollection.length)
  )
}

export default function SliderSection(props) {
  const { content } = props

  const components = ComponentFactory(content.innerHTML)

  const title =
    components.filter(c => c.props.className === `icw-slider-section-title`)[0] ||
    "We're here to help your business"

  const sliderItems = components
    .filter(
      c =>
        c.props.content &&
        c.props.content.classNames.trim().split(/\s+/).includes(`cw-slider`)
    )
    .map((elem, idx) => ({ originalIndex: idx, newsItem: elem }))

  const [sliderIndx, setSliderIndx] = React.useState(0)
  const [sliderRollIndx, setSliderRollIndx] = React.useState(0)

  React.useEffect(() => {
    if (
      sliderIndx < sliderRollIndx ||
      sliderIndx >= sliderRollIndx + NUMBER_OF_NEWS_ITEMS
    )
      setSliderIndx(sliderRollIndx)
  }, [sliderIndx, sliderRollIndx])

  // const imageContent = newsContent(newsItems[newsIndx].newsItem)

  const imageContentHolder = imageHolderNode(sliderItems[sliderIndx].sliderItem)

  return (
    <div className={`row ${props.className} ${sliderSectionStyles.wrapper}`}>
      <div className={`col-12  ${sliderSectionStyles.titleWrapper}`}>
        <div className={`row`}>
          <div className={`col-6 ${sliderSectionStyles.title}`}>
            <Trans>{title}</Trans>
          </div>
        </div>

        <div className={`row ${sliderSectionStyles.navigator}`}>
          <div
            className={`col-md-1 slider-nav-btn ${
              sliderRollIndx === 0 ? sliderSectionStyles.disabledNavigator : ``
            }`}
          >
            <a
              href="#!"
              className="nav-left"
              onClick={evt => {
                evt.preventDefault()
                if (sliderRollIndx > 0)
                  setSliderRollIndx(sliderRollIndx - NUMBER_OF_NEWS_ITEMS)
              }}
            >
              <i className="bi bi-chevron-left"></i>
            </a>
          </div>
          <div
            className="col-md-10 slider-navigator"
            style={{ borderBottom: `1px solid white` }}
          ></div>
          <div
            className={`col-md-1 slider-nav-btn ${
              sliderRollIndx >= sliderItems.length - 1
                ? sliderSectionStyles.disabledNavigator
                : ``
            }`}
          >
            <a
              href="#!"
              className="nav-right"
              onClick={evt => {
                evt.preventDefault()
                if (sliderRollIndx < sliderItems.length - 1)
                  setSliderRollIndx(sliderRollIndx + NUMBER_OF_NEWS_ITEMS)
              }}
            >
              <i className="bi bi-chevron-right"></i>
            </a>
          </div>
        </div>
        

        <div className={`row`}>
          <div className={`col-12 ${sliderSectionStyles.sliderRoll}`}>
            <div className="offset-md-1 col-md-10">
              <div className={`row ${sliderSectionStyles.sliderHolder}`}>
                {sliderFilterPerNav(sliderItems, sliderIndx, sliderRollIndx).map(
                  (item, idx) => (
                    <div
                      key={idx}
                      className={`col-md-6 ${sliderSectionStyles.sliderItem} ${
                        item.originalIndex === sliderIndx ? `active` : ``
                      }`}
                    >
                      <a
                        href="#!"
                        onClick={evt => {
                          evt.preventDefault()
                          setSliderIndx(item.originalIndex)
                        }}
                      >
                        <>{item.sliderItem}</>
                      </a>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={`row ${sliderSectionStyles.sliderItemContent}`}>
            <WPImage
              holder={imageContentHolder}
              selector={`news-image`}
              mode={DISPLAY_MODE.inline}
              className={`col-12`}
            />
        </div>
      </div>
    </div>
  )
}
